import type { SubscriptionData } from '../api/developerHub/subscriptionApi';

export type Organization = { id: string; customerId: string; name: string; [key: string]: unknown };

const createAppStore = () => ({
  organizations: [] as Organization[],
  subscriptionDetails: [] as SubscriptionData[],
  subscriptionDetailsLoaded: false,
  loading: true,

  setOrganizations(orgs: Organization[]) {
    this.organizations = orgs;
  },

  setSubscriptionDetails(data: SubscriptionData[]) {
    this.subscriptionDetails = data;
    this.subscriptionDetailsLoaded = true;
  },

  setLoading(value: boolean) {
    this.loading = value;
  },
});

export default createAppStore;
